const styles = () => ({
  textField: {
    marginTop: 16,
    minWidth: 200,
  },
  errorText: {
    color: "red",
  },
});

export default styles;
